import request from '../../request';
import { surveyTemplateQuestionsServiceAPI } from './insightsUrls';

export class surveyTemplateQuestionsService {
  static get(id) {
    return request({
      url: surveyTemplateQuestionsServiceAPI.get(id),
      method: 'GET',
    })
      .then((response) => response)
      .catch((response) => response);
  }
  // static putTag(tag) {
  //   return request({
  //     url: surveyTemplateServiceAPI.put,
  //     method: 'PUT',
  //     data: tag,
  //   })
  //     .then((response) => response)
  //     .catch((response) => response);
  // }
  // static postTag(tag) {
  //   return request({
  //     url: surveyTemplateServiceAPI.post,
  //     method: 'POST',
  //     data: tag,
  //   })
  //     .then((response) => response)
  //     .catch((response) => response);
  // }
  // static deleteTag(id) {
  //   return request({
  //     url: surveyTagServiceAPI.delete(id),
  //     method: 'DELETE',
  //   })
  //     .then((response) => response)
  //     .catch((response) => response);
  // }
  // // static mergeTag(data) {
  // //   return request({
  // //     url: tagServiceAPI.mergeTag,
  // //     method: 'POST',
  // //     data,
  // //   })
  // //     .then((response) => response)
  // //     .catch((response) => response);
  // // }
}

export default surveyTemplateQuestionsService;
